var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fa-icon',{staticClass:"text-bg-grey-6",attrs:{"title":_vm.fileType,"icon":['far', _vm.fileTypeIcon]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }